import Image from "../components/Image";

function CrmContainer() {
  const crmCards = [
    {
      key: 1,
      src: "https://res.cloudinary.com/dl5mqatis/image/upload/v1648113385/passage/passage-showcase/crm-passage/new-app-min_pstkdk.png",
    },
    {
      key: 2,
      src: "https://res.cloudinary.com/dl5mqatis/image/upload/v1648113385/passage/passage-showcase/crm-passage/app-in-progress-min_znivoy.png",
    },
    {
      key: 3,
      src: "https://res.cloudinary.com/dl5mqatis/image/upload/v1648113385/passage/passage-showcase/crm-passage/awaiting-min_h7th65.png",
    },
    {
      key: 4,
      src: "https://res.cloudinary.com/dl5mqatis/image/upload/v1648113385/passage/passage-showcase/crm-passage/not_resonding-min_ku3y6w.png",
    },
    {
      key: 5,
      src: "https://res.cloudinary.com/dl5mqatis/image/upload/v1648113385/passage/passage-showcase/crm-passage/approved-min_hehllh.png",
    },
    {
      key: 6,
      src: "https://res.cloudinary.com/dl5mqatis/image/upload/v1648113385/passage/passage-showcase/crm-passage/denied-min_qjaot0.png",
    },
    {
      key: 7,
      src: "https://res.cloudinary.com/dl5mqatis/image/upload/v1648113385/passage/passage-showcase/crm-passage/second_wind-min_pmdmpc.png",
    },
  ];
  return (
    <div
      className=" w-full h-full flex flex-col justify-center item-center"
      style={{ transformStyle: "preserve-3d" }}
    >
      <div className="crm-header w-full h-[10%] m-8">
        <Image
          src={
            "https://res.cloudinary.com/dl5mqatis/image/upload/v1648113385/passage/passage-showcase/crm-passage/Group_763-min_llffn8.png"
          }
        />
        ``
      </div>
      <div
        className="crm-content w-full h-[90%] overflow-hidden"
        style={{ transformStyle: "preserve-3d" }}
      >
        <ul
          className="crm-cards h-full flex justify-between item-center w-[160%]"
          style={{ transformStyle: "preserve-3d" }}
        >
          {crmCards.map((crm) => (
            <li
              className="crm"
              key={crm.key}
              style={{ transformStyle: "preserve-3d" }}
            >
              <Image
                containerCss={"w-full h-full"}
                imgCss={"w-full h-full object-fit rounded-3xl"}
                src={crm.src}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default CrmContainer;
